import React from "react";
import { useForm } from "../FormContext";

interface InputFieldProps {
  name: string;
  value?: string;
  onChange?: (value: string) => void;
  onBlur?: () => void;
  type?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  format?: string;
  validator?: Array<{
    regex?: string;
    message: string;
  }>;
}

export const InputFieldComponent: React.FC<InputFieldProps> = ({
  name,
  value,
  onChange,
  onBlur,
  type = "text",
  placeholder,
  required,
  className = "",
  format,
  validator,
}) => {
  const { setFieldValue, setFieldTouched, validateField, fields } = useForm();
  const fieldValue = fields[name]?.value || value || "";
  const fieldErrors = fields[name]?.errors || [];
  const hasError = fieldErrors.length > 0;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setFieldValue(name, newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleBlur = () => {
    setFieldTouched(name, true);
    validateField(name);
    if (onBlur) {
      onBlur();
    }
  };

  return (
    <input
      type={type}
      value={fieldValue}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder}
      required={required}
      className={`w-full px-2 py-1.5 text-sm rounded-lg focus:outline-none focus:ring-2 bg-transparent focus:ring-blue-500 dark:text-white border
        ${hasError ? "border-red-500" : "border-gray-300 dark:border-gray-700"}
        ${className}`}
    />
  );
};
